import { ComponentType } from 'react';
import { Bell } from './Bell';
import { BriefCase } from './BriefCase';
import { CardLock } from './CardLock';
import { Cards } from './Cards';
import { Cog } from './Cog';
import { Developers } from './Developers';
import { Expand } from './Expand';
import { Home } from './Home';
import { Identities } from './Identities';
import { Money } from './Money';
import { QuestionCircle } from './QuestionCircle';
import { Report } from './Report';

export const MenuIcons: Record<string, ComponentType> = {
  Bell,
  BriefCase,
  CardLock,
  Cards,
  Cog,
  Developers,
  Expand,
  Home,
  Identities,
  Money,
  QuestionCircle,
  Report,
};
